import { render, staticRenderFns } from "./ExportTab.vue?vue&type=template&id=c5ce93d0"
import script from "./ExportTab.vue?vue&type=script&lang=js"
export * from "./ExportTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5ce93d0')) {
      api.createRecord('c5ce93d0', component.options)
    } else {
      api.reload('c5ce93d0', component.options)
    }
    module.hot.accept("./ExportTab.vue?vue&type=template&id=c5ce93d0", function () {
      api.rerender('c5ce93d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/LayoutSettingsModal/ExportTab.vue"
export default component.exports